/**首页 头部路由表 */
export const homeNavBarRoute = [
  { id: "0", name: "首页", path: "/" },
  { id: "13", name: "普药专区", path: "/GoodsList" },
  { id: "14", name: "诊所专区", path: "/ClinicZone" },
  { id: "15", name: "器械专区", path: "/ApparatusZone" },
  { id: "16", name: "品牌专区", path: "/BrandZone" },
  { id: "19", name: "促销专区", path: "/Promotion" },
  { id: "18", name: "中药专区", path: "/ChineseMedicineZone" },
  { id: "21", name: "医院专区", path: "/PublicZone" },
  { id: "20", name: "日化专区", path: "/DailyZone" },
  /*{ id: "21", name: "积分商城", path: "/PointsMall" }*/
  { id: "22", name: "控销专区", path: "/ControlPinZone" },
  { id: "23", name: "效期专区", path: "/ValidityPeriodZone" },
];
export const defaultAanufacturerTags = [
  { level: 4, id: "A", name: "A" },
  { level: 4, id: "B", name: "B" },
  { level: 4, id: "C", name: "C" },
  { level: 4, id: "D", name: "D" },
  { level: 4, id: "E", name: "E" },
  { level: 4, id: "F", name: "F" },
  { level: 4, id: "G", name: "G" },
  { level: 4, id: "H", name: "H" },
  { level: 4, id: "I", name: "I" },
  { level: 4, id: "J", name: "J" },
  { level: 4, id: "K", name: "K" },
  { level: 4, id: "L", name: "L" },
  { level: 4, id: "M", name: "M" },
  { level: 4, id: "N", name: "N" },
  { level: 4, id: "O", name: "O" },
  { level: 4, id: "P", name: "P" },
  { level: 4, id: "Q", name: "Q" },
  { level: 4, id: "R", name: "R" },
  { level: 4, id: "S", name: "S" },
  { level: 4, id: "T", name: "T" },
  { level: 4, id: "U", name: "U" },
  { level: 4, id: "V", name: "V" },
  { level: 4, id: "W", name: "W" },
  { level: 4, id: "X", name: "X" },
  { level: 4, id: "Y", name: "Y" },
  { level: 4, id: "Z", name: "Z" }
];
// 商品标签
export const defaultGoodsLabelSet = {
  1: "特价",
  2: "买赠",
  3: "换购",
  4: "效期",
  5: "阶梯",
  6: "精品",
  7: "新特",
  8: "秒杀",
  9: "随特",
  10: "业务员",
  11: "直播商品",
  12: "院线",
  13: "拼团",
};



// WEBPACK FOOTER //
// ./src/components/nav/staticData.js